import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import menuStructure from './menuStructure';

Vue.use(Router);

const publicRoutes = ['/login', '/preview'];

const router = new Router({
	routes: [...routes]
});

// Add global route guard to protect against unauthenticated access
router.beforeEach((to, from, next) => {
	const isPublicRoute = publicRoutes.includes(to.path);

	// Allow public routes regardless of auth state
	if (isPublicRoute) {
		next();
		return;
	}

	// Check if there's a token in the query string for authentication
	// (both 'token' for HPID mode and 'token'+'accountId' for non-HP mode)
	if (to.query.token) {
		// Allow the route to proceed so App.vue can handle token exchange
		next();
		return;
	}

	// For protected routes, check if user is authenticated
	// This will be properly validated by the store
	const store = router.app?.$store;
	if (!store) {
		// Store not available yet during initial load, let it proceed
		// The App.vue component will handle the redirect
		next();
		return;
	}

	const isAuthenticated = store.getters['auth/isAuthenticated'];
	if (isAuthenticated) {
		next();
	} else {
		// Redirect to login
		next({ name: 'login', query: { redirectTo: to.path } });
	}
});

export default router;
export { routes, menuStructure };
